import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";

const formatTime = (isoString) =>
  isoString ? moment(isoString).format("YYYY-MM-DD HH:mm:ss") : "";

export const generateDeviceProductionPDF = (responseData) => {
  if (!responseData)
    throw new Error("Device production data is null or undefined");
  const dataArray = responseData.data || responseData;
  if (!Array.isArray(dataArray))
    throw new Error("Expected data to be an array");

  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });

  doc.setFontSize(16);
  doc.setFont(undefined, "bold");
  doc.text("Device Production Report", 14, 15);

  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  const generatedAt = moment().format("YYYY-MM-DD");
  doc.text(`Generated: ${generatedAt}`, 14, 22);

  const tableData = [];

  dataArray.forEach((production) => {
    const devices = production.DeviceProdsItems || [];

    if (devices.length === 0) {
      tableData.push([
        production.ProductionNo || "",
        production.ProductionName || "",
        production.ProductionDesc || "",
        formatTime(production.ProductionTime),
        "No devices",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]);
      return;
    }

    devices.forEach((device) => {
      tableData.push([
        production.ProductionNo || "",
        production.ProductionName || "",
        production.ProductionDesc || "",
        formatTime(production.ProductionTime),
        device.DeviceNo || "",
        device.DeviceName || "",
        device.OemNo || "",
        device.DealerNo || "",
        device.CustomerNo || "",
        device.NodeType || "",
        device.SiteType || "",
        device.Mac || "",
        device.Product || "",
        device.Model || "",
        device.Type || "",
      ]);
    });
  });

  autoTable(doc, {
    startY: 28,
    head: [
      [
        {
          content: "Device Production Info",
          colSpan: 4,
          styles: {
            fillColor: [68, 114, 196],
            halign: "center",
            fontStyle: "bold",
            textColor: [255, 255, 255],
          },
        },
        {
          content: "Device Details",
          colSpan: 11,
          styles: {
            fillColor: [68, 114, 196],
            halign: "center",
            fontStyle: "bold",
            textColor: [255, 255, 255],
          },
        },
      ],
      [
        "No",
        "Name",
        "Description",
        "Production Time",
        "Device No",
        "Device Name",
        "OEM",
        "Dealer",
        "Customer",
        "Node Type",
        "Site Type",
        "MAC",
        "Product",
        "Model",
        "Type",
      ],
    ],
    body: tableData,
    styles: {
      fontSize: 7,
      cellPadding: 2,
      lineColor: [200, 200, 200],
      lineWidth: 0.1,
      valign: "top",
    },
    headStyles: {
      fillColor: [217, 225, 242],
      textColor: [0, 0, 0],
      fontStyle: "bold",
      fontSize: 8,
      halign: "center",
    },
    columnStyles: {
      // Production Info — green tint
      0: { cellWidth: 10, fillColor: [226, 239, 218] }, // No
      1: { cellWidth: 22, fillColor: [226, 239, 218] }, // Name
      2: { cellWidth: 22, fillColor: [226, 239, 218] }, // Description
      3: { cellWidth: 26, fillColor: [226, 239, 218] }, // Production Time
      // Device Details — blue tint
      4: { cellWidth: 12, fillColor: [207, 226, 243] }, // Device No
      5: { cellWidth: 20, fillColor: [207, 226, 243] }, // Device Name
      6: { cellWidth: 24, fillColor: [207, 226, 243] }, // OEM
      7: { cellWidth: 16, fillColor: [207, 226, 243] }, // Dealer
      8: { cellWidth: 16, fillColor: [207, 226, 243] }, // Customer
      9: { cellWidth: 16, fillColor: [207, 226, 243] }, // Node Type
      10: { cellWidth: 16, fillColor: [207, 226, 243] }, // Site Type
      11: { cellWidth: 28, fillColor: [207, 226, 243] }, // MAC
      12: { cellWidth: 14, fillColor: [207, 226, 243] }, // Product
      13: { cellWidth: 20, fillColor: [207, 226, 243] }, // Model
      14: { cellWidth: 10, fillColor: [207, 226, 243] }, // Type
    },
    margin: { top: 28, left: 12.5, right: 12.5 },
  });

  return doc;
};

export const downloadDeviceProductionPDF = (
  productionData,
  filename = "device_production_report.pdf"
) => {
  try {
    const doc = generateDeviceProductionPDF(productionData);
    doc.save(filename);
    return true;
  } catch (error) {
    console.error("Error creating PDF:", error);
    throw error;
  }
};
